module.exports = __webpack_public_path__ + "img/49_5.5808b722.png";